<template>
  <div id="compare-drawer" ref="compareDrawer" class="offcanvas offcanvas-bottom h-auto bg-light compare-drawer" tabindex="-1" aria-labelledby="" data-bs-backdrop="false" data-bs-scroll="true">
    <div class="container py-3 py-lg-5 h-100">
      <div class="row align-items-center h-100">
        <div v-if="!(comparison.a || comparison.b)" class="col-12 col-lg-9 order-lg-2">
          <div class="row">
            <div class="col-12 text-center">
              <slot name="product-compare-start"></slot>
            </div>
          </div>
        </div>

        <div v-if="comparison.a || comparison.b" class="col-12 col-lg-8 offset-lg-1 order-lg-2">
          <div class="row align-items-stretch">
            <div v-for="product in comparisonProducts" class="col-6">
              <div v-if="product" class="compare-drawer-product product-card h-100 d-flex flex-column">
                <div class="product-compare-actions">
                  <button class="product-compare-remove bg-none" v-on:click="$emit('removeFromComparison', product.product_id)">
                    <slot name="close-circle-icon" :product="product"></slot>
                  </button>
                </div>

                <h3 class="card-title h4" v-html="product.title"> </h3>
                <strong class="card-supertitle">
                  <span v-for="term in product.series" :class="'text-' + term.color">
                    {{ term.title }}
                  </span>
                </strong>
                <div class="rte d-none d-lg-block fw-medium mb-2">
                  {{ product.description }}
                </div>
                <div v-if="product.msrp_from" class="product-card-price fw-bold mb-2">
                  <slot name="product-result-price-prefix">From</slot>
                  {{ product.msrp_from }}
                </div>
                <div class="product-card-rating mb-2" data-bv-show="inline_rating" :data-bv-product-id="product.product_id"></div>

              </div>

              <!-- empty comparison slot -->
              <div v-if="!product" class="compare-drawer-product product-card h-100 text-center d-flex flex-column align-items-center justify-content-center">
                <div>
                  <slot name="product-compare-empty"></slot>
<!--                   <h3 class="card-title h4">
                    <slot name="product-compare-empty-title"></slot>
                  </h3>
                  <div class="rte d-none d-lg-block">
                    <slot name="product-compare-empty-description"></slot>
                  </div>
 -->                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3 order-lg-1 mt-2 my-lg-0">
          <button class="btn btn-primary mb-2 mb-lg-3" :disabled="!(comparison.a && comparison.b)" @click="$emit('navigateToComparison')">
            <slot name="product-compare-compare-button-label"></slot>
          </button>
          <button class="btn btn-secondary" data-bs-dismiss="offcanvas">
            <slot name="product-compare-close-button-label"></slot>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items', 'comparison'],
  computed: {
    comparisonProducts() {
      return [
        this.items.find((a) => a.product_id == this.comparison.a),
        this.items.find((a) => a.product_id == this.comparison.b)
      ]
    }
  },
  emits: ['removeFromComparison', 'navigateToComparison', 'compareDrawerOpen'],
  mounted() {
    this.$refs.compareDrawer.addEventListener('show.bs.offcanvas', () => {
      this.$emit('compareDrawerOpen')
    })
  }
}
</script>
